// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"b786bb90","365":"fded60c5","371":"2ad54ba1","453":"beadc365"}[chunkId] + ".chunk.js";
};